import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const useNavigationGuard = (warningState) => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (warningState) {
        event.preventDefault();
        event.returnValue =
          "Are you sure you want to leave? Changes may be lost.";
      }
    };

    const handleNavigation = (event) => {
      if (
        warningState &&
        !window.confirm(
          "Are you sure you want to leave? Unsaved changes will be lost."
        )
      ) {
        event.preventDefault();
        navigate(1); // Stay on the same page
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handleNavigation);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handleNavigation);
    };
  }, [warningState, navigate]);
};

export default useNavigationGuard;
